import React from "react";
import Snackbar from "@mui/material/Snackbar";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";

function AlertComponent({ title, msg, handleCloseAlert, openAlert }) {
  // let alertClass = "alertError";
  // if (msg === "success") {
  //   alertClass = "alertSuccess";
  // }
  const validSeverities = ["error", "info", "success", "warning"];
  const severity = validSeverities.includes(msg) ? msg : "info";

  const alertClass = msg === "success" ? "alertSuccess" : "alertError";
  return (
    <div>
      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
      >
        {/* <Alert
          onClose={handleCloseAlert}
          severity={msg}
          sx={{ width: "100%" }}
          className={alertClass}
        >
          {title}
        </Alert> */}
        <Alert
          onClose={handleCloseAlert}
          severity={severity}
          sx={{ width: "100%" }}
          className={alertClass}
        >
          {title}
        </Alert>
      </Snackbar>
    </div>
  );
}

AlertComponent.propTypes = {
  title: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired,
  handleCloseAlert: PropTypes.func.isRequired,
  openAlert: PropTypes.bool,
};

AlertComponent.defaultProps = {
  openAlert: false,
};

export default AlertComponent;
